<template>
  <collateral-folder-menu
    :folders="elements"
    :count="count"
    @search="onSearch"
    @reached-bottom="loadMore"
    @folder-clicked="onFolderClicked"
    @folder-create="onFolderCreate"
    @folder-delete="onPreFolderDelete"
    @title-change="onTitleChange"
  />
</template>

<script>

import _ from 'lodash';
import Listable from '@/components/mixins/listable';
import { EventBus } from '@/event-bus';
import CollateralFolderMenu from './CollateralFolderMenu';

export default {

  name: 'CollateralFolderMenuContainer',
  components: {
    CollateralFolderMenu,
  },
  mixins: [Listable],
  props: {
    source: {
      type: String,
      default: 'folders',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    pageSize: {
      type: Number,
      default: 40,
    },
  },
  data() {
    return {};
  },
  computed: {
    elements() {
      return [...this.storeState[this.source][this.getter]];
    },
    count() {
      return this.$store.state.folders.count;
    },
    fetchRoute() {
      return 'folders/customAddPage';
    },
    isAdminMode() {
      return this.$store.state.account.isAdminMode;
    },
  },
  mounted() {
    this.queryParams.scope = this.$store.getters['account/scope'];
  },
  methods: {
    onSearch: _.debounce(function onSearch(evt) {
      this.search = evt;
    }, 200),
    onFolderClicked(selectedFolder) {
      // This logic was present on FolderSelectorContainer.vue, may change with this new approach
      const route = `/assets/folder/${selectedFolder.pk}`;
      this.$router.push(route);
    },
    onFolderCreate(name) {
      this.$store.dispatch('folders/newItem', { name, private: false }).then((response) => {
        this.$router.push(`/assets/folder/${response.data.pk}/`);
      }).catch((error) => {
        EventBus.$emit('toast-error', 'Failed to create folder. Please try again');
      });
    },
    onFolderDelete(folder) {
      this.$store.dispatch('folders/deleteItem', folder.pk);
    },
    onPreFolderDelete(folder) {
      let deleteMessage = `Are you sure you want to delete “${folder.name}”?`;
      if (this.isAdminMode) {
        deleteMessage += ' Deleting this folder will remove this folder from all user accounts.';
      }
      EventBus.$emit('confirm', {
        title: deleteMessage,
        positiveText: 'Delete',
        negativeText: 'Cancel',
        callback: (confirm) => {
          if (confirm) {
            this.onFolderDelete(folder);
            if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
              this.$mixpanel.track('create_album', {
                account_id: this.$store.state.account.user.user.email,
                album_folder: folder,
              });
            }
          }
        },
      });
    },
    onTitleChange(evt) {
      const payload = {};
      const newName = evt.name.trim();
      if (newName !== '') {
        payload.name = newName;
      } else {
        payload.name = 'New folder';
      }
      this.$store.dispatch('folders/updateItem', { folderId: evt.folderPk, payload });
    },
  },
};
</script>

<style lang="css" scoped>
</style>
